export const COLORS = {
  "black-1": "#000000",
  "black-opacity-1": "#00000033",
  "black-opacity-2": "#00000066",
  "black-opacity-3": "#00000099",
  "black-opacity-4": "#000000CC",
  "error-1": "#EB001B",
  "green-1": "#237C47",
  "grey-1": "#808080",
  "orange-1": "#FF4B00",
  "orange-2": "#933913",
  "orange-3": "#FF5D1A",
  "red-1": "#FF2E00",
  "white-opacity-1": "#FFFFFF1A",
  "white-opacity-2": "#FFFFFF33",
  "white-opacity-3": "#FFFFFF4D",
  "white-opacity-4": "#FFFFFF66",
  "white-opacity-5": "#FFFFFF80",
  "secondary-60": "#919090",
  "dark-3": "#B8B8B8",

  surface: "var(--surface)",
  "surface-bright": "var(--surface-bright)",
  "surface-container": "var(--surface-container)",
  "surface-container-high": "var(--surface-container-high)",
  "surface-container-low": "var(--surface-container-low)",
  "on-surface": "var(--on-surface)",
  "on-surface-variant": "var(--on-surface-variant)",

  primary: "var(--primary)",
  "on-primary": "var(--on-primary)",

  outline: "var(--outline)",
  "outline-variant": "var(--outline-variant)",
};
